export default __webpack_public_path__ + "static/media/banner-practice-l.cd249ea0.png";